import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const services = [
    { id: 1, title: 'Accident Repairs', price: '£200 - £3000', icon: '🚗' },
    { id: 2, title: 'Dent Removal', price: '£80 - £500', icon: '🔨' },
    { id: 3, title: 'Scratch Repairs', price: '£50 - £300', icon: '✨' },
    { id: 4, title: 'Full Body Respray', price: '£1000 - £4000', icon: '🎨' },
    { id: 5, title: 'Alloy Wheel Repair', price: '£60 - £150', icon: '🛞' },
    { id: 6, title: 'Paint Correction', price: '£150 - £600', icon: '⚙️' },
  ];

  const testimonials = [
    {
      id: 1,
      name: 'John Smith',
      text: 'Excellent service! My car was fixed perfectly and on time. Highly recommended!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      text: 'Professional team with great attention to detail. Very satisfied with the results.',
      rating: 5,
    },
    {
      id: 3,
      name: 'Michael Brown',
      text: 'Great prices and fantastic workmanship. Will definitely come back here.',
      rating: 5,
    },
  ];

  const galleryImages = [
    '/assets/photo1.jpeg',
    '/assets/photo2.jpeg',
    '/assets/photo3.jpeg',
    '/assets/photo4.jpeg',
    '/assets/photo5.jpeg',
    '/assets/photo6.jpeg',
  ];

  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content container">
          <h1 className="hero-title">Expert Car Body Repairs in West Drayton</h1>
          <p className="hero-subtitle">
            Professional accident repair, dent removal, and paint correction services
          </p>
          <div className="hero-buttons">
            <Link to="/quote" className="btn btn-primary btn-large">
              Get a Custom Quote → 
            </Link>
            <Link to="/services" className="btn btn-secondary btn-large">
              View Our Services
            </Link>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Cars Fixed</span>
            </div>
            <div className="stat">
              <span className="stat-number">15+ Yrs</span>
              <span className="stat-label">Experience</span>
            </div>
            <div className="stat">
              <span className="stat-number">98%</span>
              <span className="stat-label">Customer Satisfaction</span>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="trust-section container p-40">
        <div className="trust-badges">
          <div className="badge">
            <span className="badge-icon">✓</span>
            <p>Insurance Approved</p>
          </div>
          <div className="badge">
            <span className="badge-icon">✓</span>
            <p>Certified Technicians</p>
          </div>
          <div className="badge">
            <span className="badge-icon">✓</span>
            <p>Quality Guarantee</p>
          </div>
          <div className="badge">
            <span className="badge-icon">✓</span>
            <p>Fast Turnaround</p>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview container p-40">
        <h2 className="text-center">Our Services</h2>
        <p className="section-intro text-center">
          Comprehensive car body repair services to get your vehicle back in perfect condition
        </p>
        <div className="grid grid-3">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p className="price">{service.price}</p>
              <p>Professional repair service with quality guarantee</p>
              <Link to="/services" className="btn btn-secondary">
                Learn More
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section p-40">
        <div className="container">
          <h2 className="text-center">Our Recent Work Gallery</h2>
          <p className="section-intro text-center">
            See the quality of our work from recent projects
          </p>
          <div className="gallery-grid">
            {galleryImages.map((imageSrc, index) => (
              <div key={imageSrc} className="gallery-item">
                <img
                  src={imageSrc}
                  alt={`Repair work ${index + 1}`}
                  className="gallery-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          {/* <div className="text-center mt-40">
            <Link to="/services" className="btn btn-primary">
              View Full Gallery
            </Link>
          </div> */}
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section container p-40">
        <h2 className="text-center">What Our Customers Say</h2>
        <div className="grid grid-3">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="stars">
                {'⭐'.repeat(testimonial.rating)}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <p className="testimonial-author">— {testimonial.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content container">
          <h2>Ready to Get Your Car Fixed?</h2>
          <p>Contact us today for a free, no-obligation quote</p>
          <div className="cta-buttons">
            <Link to="/quote" className="btn btn-primary btn-large">
              Request a Quote
            </Link>
            <a href="https://wa.me/447888396099" className="btn btn-secondary btn-large">
              💬 Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
